export default __webpack_public_path__ + "static/media/pp-group-logo.8292c325.jpg";